import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Randomcode } from "../../components_root/rendom_code";
import { Toast } from '../../components_root/ToastContext';
import { MdArrowBackIos, MdClose, MdDone, MdMoney, MdSave, MdSearch } from "react-icons/md";
import { db } from "../../firebase";
import {
    collection,
    query,
    where,
    onSnapshot,
    getDocs
} from "firebase/firestore";
import { Save_log_history } from "../../log_history_root/save_log_history";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Update_ledger_books_accounts({ data }) {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState();
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const servicetablename = "accountingfinancedb";
    const [slug, setSlug] = useState("");
    const [account_type, setAccount_type] = useState("");
    const [accountguid, setaccountguid] = useState("");
    const [account_status, setAccount_status] = useState(false);
    const [verify_note, setVerify_note] = useState("");
    useEffect(() => {
        setaccountguid(data?.accountguid);
        setDescription(data?.description);
        setAccount_type(data?.account_type);
        setAccounts_name(data?.name);
        setMobile(data?.mobile);
        setAccount_status(data?.status);
    }, [data]);
    const [accounting_groups_raw, setaccounting_groups_raw] = useState([]);

    useEffect(() => {
        const masterQuery = query(
            collection(db, "accounting_groups_list_master")
        );

        const unsubscribeMaster = onSnapshot(masterQuery, (snapshot) => {
            const rawList = snapshot.docs.map((d) => d.data());

            setaccounting_groups_raw(rawList); // 👈 keep raw

        });

        return () => unsubscribeMaster();
    }, []);
    const handleCreate = async () => {
        const logid = Randomcode(25);
        if (!account_type || !account_type.trim()) {
            Toastshow("Please Select role type.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        if (!verify_note || !verify_note.trim()) {
            Toastshow("Please enter a verification note.");
            return;
        }
        const dataupdates = {
            log_id: logid,
            description: description,
            name: accounts_name,
            mobile,
           // account_type:account_type,
             account_role_type: account_type,
            status: account_status,
            // Add other necessary fields here
        };
        create_log(logid, dataupdates, accountguid, "Account", description, verify_note);
    };
    const create_log = async (logid, dataupdates, filedid, account_type, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + description;
        const log_data = {
            logid,
            history_type: "Ledger book",
            servicetablename: "accountingfinancedb",
            tablename: "ledger_accounts",
            filedname: "accountguid",
            filedid: filedid,
        
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates, 
            description: description,
           // account_type: account_type,
            account_role_type: account_type,
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    return (
        <div >
            <div className="items-back ">
                <table>
                    <tr>
                        <td><div className="text-h2 bold">Change role type </div></td>
                    </tr>
                    <tr>
                        <td>
                             <select
                                value={account_type}
                                onChange={(e) => setAccount_type(e.target.value)}
                                className="text-h2 bold p-2">
                                <option value="">Select account</option>
                                <option value="income">Income</option>
                                <option value="expense">Expense</option>
                                <option value="assets">Assets</option>
                                <option value="liabilities">Liabilities</option>
                                <option value="equity">Equity</option>
                            </select>
                            
                            {/* <select
                                value={account_type}
                                onChange={(e) => setAccount_type(e.target.value)}
                                className="text-h2 bold p-2"
                            >
                                <option value="">Select account</option> 
                                {accounting_groups_raw.reduce((acc, item) => {
                                    const key = `${item.group}_${item.group_title}`; 
                                    if (!acc[key]) {
                                        acc[key] = {
                                            label: `${item.group_title} (${item.group})`,
                                            items: []
                                        };
                                    } 
                                    acc[key].items.push(item);
                                    return acc;
                                }, {}) &&
                                    Object.values(
                                        accounting_groups_raw.reduce((acc, item) => {
                                            const key = `${item.group}_${item.group_title}`;

                                            if (!acc[key]) {
                                                acc[key] = {
                                                    label: `${item.group_title} (${item.group})`,
                                                    items: []
                                                };
                                            }

                                            acc[key].items.push(item);
                                            return acc;
                                        }, {})
                                    ).map((group) => (
                                        <optgroup key={group.label} label={group.label}>
                                            {group.items.map((item) => (
                                                <option
                                                    key={item.groupid}
                                                    value={item.groupid}   // ✅ THIS IS WHAT YOU WANT
                                                >
                                                    <div className="fcap">{item.account_type.replaceAll("_", " ")}</div>
                                                </option>
                                            ))}
                                        </optgroup>
                                    ))}
                            </select> */}
                        </td>
                    </tr>
                    <tr>
                        <td><input type="text" className="p-2" value={accounts_name} onChange={(e) => {
                            setAccounts_name(e.target.value); 
                        }} maxLength={30} placeholder="Enter account name" /></td>
                    </tr>
                    <tr>
                        <td><input type="phone" className="p-2" value={mobile} onChange={(e) => {
                            setMobile(e.target.value); 

                        }} maxLength={30} placeholder="Enter Mobile number" /></td>
                    </tr>


                    <tr>
                        <td><div className="text-h2 bold">Description</div></td>
                    </tr>
                    <tr>
                        <td><textarea className="p-2" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                value={verify_note}
                                onChange={(e) => setVerify_note(e.target.value)}
                                maxLength={100}
                                placeholder="Enter a verification note"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="">
                                <table className="table-fixed">
                                    <tr>
                                        <td>
                                            <div
                                                onClick={() => setAccount_status(true)}
                                                className={`fill p-2 cursor ${account_status === true ? "button-ui green-back" : "button-ui2"}`}
                                            >
                                                <MdDone className="icon" />
                                                Activate
                                            </div>
                                        </td>

                                        <td>
                                            <div
                                                onClick={() => setAccount_status(false)}
                                                className={`fill p-2 cursor ${account_status === false ? "button-ui red-back" : "button-ui2"}`}
                                            >
                                                <MdClose className="icon" />
                                                Deactivate
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>

                </table>
                <div className="button-ui p-2 fill text-h2 fcap  cursor" onClick={() => handleCreate()}><MdSave className="icon" />Update </div>

            </div>
        </div>
    );
}
